<template>
    <div>
        <custom-dialog
            v-loading="loading"
            title="请选择打印机"
            @close="cancel"
            :visible.sync="printDialogShow"
            width="500px"
            :append-to-body="appendToBody"
        >
            <div v-for="item in showList" :key="item.clientId" slot="content">
                <div class="group-title">客户端：{{ item.hostName }}</div>
                <div class="group">
                    <el-radio v-for="obj in item.printerInfos" @input="handleChange" :key="obj.id" v-model="printId"
                        :label="obj.id">{{ obj.printerName
                        }}</el-radio>
                </div>
            </div>
            <!-- 样式修改 暂时注释 -->
            <!-- <div class="client-warp">
                <div>客户端：</div>
                <el-select style="width:80%" v-model="clientId" placeholder="请选择">
                    <el-option v-for="item in showList" :key="item.clientId" :label="item.hostName" :value="item.clientId">
                    </el-option>
                </el-select>
            </div> -->
            <span slot="footer" class="dialog-footer display-f just-b">
                <div><el-checkbox v-model="setDefault">设置为个人默认打印机</el-checkbox></div>
                <div>
                    <custom-button @click="cancel" size="middle">取 消</custom-button>
                    <custom-button type="primary" @click="handlePrint" size="middle">打 印</custom-button>
                </div>
            </span>
        </custom-dialog>
    </div>
</template>
  
<script>
import { queryPrintClient, printOrder,getPrintContent,printLocal } from '@/api/print'
import { isNull } from '@/utils/validateBase'
import { Utils } from '../utils/utils';
import CustomDialog from '@/components/customDialog/CustomDialog.vue';
import { PrintDto } from '@/DTO';
export default {
    // 定义引入的组件
    components: { CustomDialog },
    props: {
        printListObj: Array,//批量打印
        id: String | Number,//订单id
        areaId: String | Number,//订单id
        orderType: String | Number,//订单类型 0挂号 1中药 2理疗 3隐秘 4划价单
        printType: String | Number,//打印类型 1小票 2处方
        printDialogShow: Boolean,
        isBatch: {
            type: Boolean,
            default: false
        },//是否批量打印
        appendToBody: {
            type: Boolean,
            default: false
        },//是否插入至 body 元素上，嵌套弹窗时使用
    },
    data() {
        return {
            dialogVisible: false,
            printId: '',//当前打印机id
            loading: false,//加载动画
            list: [],
            clientId: '',//打印机客户端id
            printerName: '',
            showList: [],
            setDefault: false,//是否设置为个人打印机
            userDefaultPrint: true,//是否可以使用个人默认打印机
            deptDefaultPrint: true,//是否可以使用门店默认打印机
            defaultPrintList: {},//默认打印机对象
            printList: [],//打印机列表
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() {
        this.dialogVisible = true
        // this.queryPrintClient()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 单选值改变
         */
        handleChange(val) {
            this.list.forEach(item => {
                if (item.id === val) {
                    this.clientId = item.clientId
                    this.printerName = item.printerName
                }
            })
        },
        /**
         * 获取打印客户端信息
         */
        queryPrintClient() {
            let list = [];
            queryPrintClient().then(res => {
                let { code, data } = res
                if (code == 200) {
                    data.forEach((item, indexI) => {
                        item.printerInfos.forEach((obj, indexO) => {
                            obj.id = item.clientId + obj.printerName
                            obj.clientId = item.clientId
                            list.push(obj)
                        })
                    })
                    this.list = list
                    this.showList = data
                    let result = list.filter(item => { return item.id === this.printId })
                    if (Utils.gt(result.length, 0)) {
                        this.clientId = result[0].clientId
                        this.printerName = result[0].printerName
                        this.handlePrint()
                    }
                }
            })
        },
        /**
         * 取消
         */
        cancel() {
            this.$emit('closePrintPrescription')
            this.dialogVisible = false
        },
        /**
         * 打印
         * clientId 打印机客户端id
         * id 订单id
         * orderType 订单类型 0挂号 1中药 2理疗 3隐秘 4划价单
         * printType 打印类型 1小票 2处方
         * printerName 打印机名称
         */
        handlePrint() {
            if(isNull(this.clientId) || isNull(this.printerName)) return this.$message.error('请选择打印机')
            let params = {
                clientId: this.clientId,
                deptId: this.$session.get('deptId'),
                printerName: this.printerName,
            }
            if (this.isBatch) {
                // 批量打印
                params.printList = this.printListObj
                PrintDto.batchPrint(params).then(res => {
                    if (res.code == 200) {
                        this.cancel()
                        this.$emit('printSuccessBatch',res.data)
                    }
                })
            } else {
                params.id = this.id
                params.orderType = this.orderType
                params.printType = this.printType
                params.areaId = this.areaId
                printOrder(params).then(res => {
                    if (res.code == 200) {
                        this.$message.success('打印成功！')
                        this.cancel()
                        this.$emit('printSuccess')
                    }
                })
            }

            if (this.setDefault) {
                this.savePrintSetting()
            }
        },
        //设置个人打印机
        //保存默认设置
        savePrintSetting() {
            let obj = {
                deptId: this.$session.get('deptId'),
                printType: this.printType,
                userPrintDefault: {
                    printerName: this.printerName,
                    clientId: this.clientId,
                }
            }
            PrintDto.editPrintDefault(obj).then(res => {
                if (res.code == 200) {
                    this.$message.success('保存成功！')
                }
            })

        },
        async getList() {
            let list = [];
            let res = await PrintDto.getPrintClientList()
            this.printList = res.data
            res.data.forEach((item, indexI) => {
                item.printerInfos.forEach((obj, indexO) => {
                    obj.id = item.clientId + obj.printerName
                    obj.clientId = item.clientId
                    list.push(obj)
                })
            })
            this.list = list
            this.showList = res.data
            if (_.isEmpty(res.data)) {
                this.$message.error('暂无打印机');
                return false
            }
        },
        //查看是否使用默认打印机
        async useDefaultPrint(printMap) {
          const printInfo = {
              deptId: this.$session.get('deptId'),
              printType: printMap && printMap.printType ? printMap.printType : this.printType,
              orderType: printMap && printMap.orderType ? printMap.orderType : this.orderType,
              id: printMap && printMap.id ? printMap.id : this.id,
              areaId: printMap && printMap.areaId ? printMap.areaId : this.areaId
          }
          // 医生 && 打处方 || 打病历 默认走本地打印
            if(!isNull(this.$session.get('user').doctorId) && (printInfo.printType == 2 || printInfo.printType == 6)){
              if(this.isBatch){
                this.localBatchPrint()
              }else{
                this.localPrint(printInfo)
              }
            }else{
              await this.getList()
              //获取是否有默认打印机
              PrintDto.getPrintDefault({ printType: printInfo.printType, deptId: printInfo.deptId }).then(res => {
                  if (res.code == 200) {
                      this.defaultPrintList = res.data
                      this.choosePrint(printInfo)
                  }
              })
            }
        },
        //判断使用哪一个打印机
        choosePrint(printInfo) {
            let obj = printInfo
            if (this.defaultPrintList.userPrintDefault && this.userDefaultPrint) {
                obj = {
                    ...obj,
                    ...this.defaultPrintList.userPrintDefault
                }
                let userPrintId = this.defaultPrintList.userPrintDefault.clientId + this.defaultPrintList.userPrintDefault.printerName

                this.getPrintList(obj, userPrintId, '1')
            } else if ((!this.defaultPrintList.userPrintDefault && this.defaultPrintList.deptPrintDefault && this.deptDefaultPrint) || (!this.userDefaultPrint && this.defaultPrintList.deptPrintDefault && this.deptDefaultPrint)) {

                obj = {
                    ...obj,
                    ...this.defaultPrintList.deptPrintDefault
                }
                let deptPrintId = this.defaultPrintList.deptPrintDefault.clientId + this.defaultPrintList.deptPrintDefault.printerName

                this.getPrintList(obj, deptPrintId, '2')
            } else {
                if (_.isEmpty(this.printList)) {
                    return false
                }
                this.$emit('setPrintDiaShow')
            }
        },
        //获取打印机列表
        getPrintList(obj, id, type) {
            if (!_.isEmpty(this.printList)) {
                let arr = PrintDto.computeHasPrint(this.printList, id)
                if (type == '1' && _.isEmpty(arr)) {
                    this.userDefaultPrint = false;
                    this.choosePrint(obj)
                }
                if (type == '2' && _.isEmpty(arr)) {
                    this.deptDefaultPrint = false;
                    this.choosePrint(obj)
                }
                if (!_.isEmpty(arr)) {
                    this.printOrder(obj)
                }
            }
        },
        //调打印机
        printOrder(obj) {
            if (this.isBatch) {
                let { clientId, deptId, printerName,areaId } = obj
                let params = {
                    deptId, printList: this.printListObj,clientId,printerName,areaId
                }
                PrintDto.batchPrint(params).then(res => {
                    if (res.code==200) {
                        this.$emit('printSuccessBatch',res.data)
                    }
                })
            } else {
                PrintDto.printOrder(obj).then(res => {
                    if (res) {
                        this.$message.success('打印成功！')
                        this.$emit('printSuccess')
                    }
                })
            }
        },
        //本地打印
        async localPrint(printInfo){
          let {code,data} = await  getPrintContent(printInfo)
          if (code == 200 && data && data.length > 0) {
            //  循环打印
            data.forEach(item => {
              var requestId = this.$moment(Date.now()).format("YYYYMMDDHHmmssSSS");
              // TODO ...
              item =  item.includes('"printerName"') ? item.replace(/"printerName":"[^"]*"/, '"printerName":"localprint"') : item.replace('{', '{"printerName":"localprint",')

              item = item.replace(/"printerName":""/g, '"printerName":"localprint"');
              var data = '{"paperLandscape":false,' + item.substring(1);
              var printObj = '{"type":"fix_template_print","requestId":"'+requestId+'","data":'+ data +'}';
              printLocal(printObj)
            })
          }
        },
        localBatchPrint(){
          this.printListObj.forEach(item => {
            item.deptId = this.$session.get('deptId')
            this.localPrint(item)
          })
        }
    },
}
</script>
<style lang="less" scoped>
// /deep/.el-dialog__body{
//     padding: 20px !important;
// }
// /deep/.el-dialog__header {
//     background: #EBF2FF;
//     border-radius: 4px 4px 0px 0px;
//     color: #333;
//     font-size: 16px;
//     font-weight: 500;
// }
.client-warp {
    display: flex;
    align-items: center;
}

.group-title {
    font-size: 16px;
    margin-top: 8px;
    font-weight: 500;
    color: #1F2329;
}

.group {
    padding-left: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: column;

    .el-radio {
        margin-top: 20px;
    }
}

.dialog-footer {
    border-top: 1px solid #EBEAEE;
    // padding-bottom: 0px;
}
</style>